import { Theme } from "@mui/material/styles";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    heading: {
      fontSize: theme.typography.pxToRem(17),
      fontWeight: theme.typography.fontWeightRegular,
      color: "#000",
      lineHeight: "28px",
    },
    CustomMuiDrawer: {
      "& .MuiDrawer-paper": {
        top: "64px",
        height: "calc(100% - 64px)",
      },
    },
    swipeableDrawer: {
      width: 300,
      marginTop: "80",
    },
    backdrop: {
      zIndex: theme.zIndex.modal + 1,
      color: "#fff",
    },
  })
);
